$(function () {

	$('.lk-order-tooltip').on('mouseenter', (e) => {
		let self = $(e.currentTarget),
			content = self.find('.lk-order-tooltip__content'),
			top = self[0].getBoundingClientRect().top - content.outerHeight(true),
			header_height = $('.header').outerHeight(true)

		self.addClass('hover')

		if (top < header_height) {
			self.addClass('to-bottom')
		} else {
			self.removeClass('to-bottom')
		}
	});

	$('.lk-order-tooltip').on('mouseleave', (e) => {
		let self = $(e.currentTarget)

		self.removeClass('hover')
	});

	$('.js-open-mobile-filter').on('click',(e) => {
		$('.lk-order-page-modal').addClass("active");
	});
	$('.js-close-order-modal').on('click',(e) => {
		$('.lk-order-page-modal').removeClass("active");

		return false;
	});

})